import { render } from "./PageWrapper.vue.js?vue&type=template&id=139670b4&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageWrapper.vue?vue&type=template&id=139670b4&scoped=true"
import script from "./PageWrapper.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageWrapper.vue?vue&type=script&lang=js"

import "./PageWrapper.vue.scss?vue&type=style&index=0&id=139670b4&scoped=true&lang=scss!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageWrapper.vue?vue&type=style&index=0&id=139670b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139670b4"],['__file',"src/Web/scripts/components/PageWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "139670b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('139670b4', __exports__)) {
    api.reload('139670b4', __exports__)
  }
  
  module.hot.accept("./PageWrapper.vue.js?vue&type=template&id=139670b4&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageWrapper.vue?vue&type=template&id=139670b4&scoped=true", () => {
    api.rerender('139670b4', render)
  })

}


export default __exports__